
import { requests } from '../api.service';
import { ENUMS_URL } from '../../utils/Endpoints';

export const EnumService = {
    getEnums: () => requests.get(ENUMS_URL),
};
